import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
const SchoolCabinet = () => {
  useEffect(() => {
    document.title = "School Cabinet - St. Francis Xavier School";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>School</li>
          <li>School Cabinet</li>
        </ul>
      </div>
      <section className="innerbody">
        <div className="container schoolcabinet">
          <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/headboy.jpg"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AMAN </h3>
                <h4>(HEAD BOY)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/headgirl.jpg"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KHUSHI </h3>
                <h4>(HEAD GIRL)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrheadboy.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>EVAN </h3>
                <h4>(JR HEAD BOY)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrheadgirl.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>MANYA </h3>
                <h4>(JR HEAD GIRL)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/viceheadboy.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>PIYUSH KUMAR </h3>
                <h4> (VICE-HEAD BOY)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/viceheadgirl.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>VAISHNAVI PAWAR </h3>
                <h4> (VICE-HEAD GIRL)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/stageSecretary.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>SAMYAN </h3>
                <h4>(STAGE SECRETARY)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/stageSecretary1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>PIHU </h3>
                <h4>(STAGE SECRETARY)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrsecretary1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AARAV </h3>
                <h4>(JR STAGE SECRETARY)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrsecretary.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>HARDIKA </h3>
                <h4>(JR STAGE SECRETARY)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/disciplineminister.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DEV </h3>
                <h4> (DISCIPLINE MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/disciplineminister1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>YASHIKA </h3>
                <h4> (DISCIPLINE MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrdisciplineminister.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>MANVI </h3>
                <h4>(JR DISCIPLINE MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/jrdisciplineminister1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DIWAN </h3>
                <h4>(JR DISCIPLINE MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/curltural-minister.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KARTIK </h3>
                <h4>(CULTURAL MINISTER)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/cultural-minister.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DEVIKA </h3>
                <h4> (CULTURAL MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/academic-minister.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>EKANSH </h3>
                <h4>(ACADEMIC MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/academic-minister1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>YASHSVI </h3>
                <h4>(ACADEMIC MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/health-minister.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>HASHMITA </h3>
                <h4> (HEALTH & ENVIROMENT MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/health-minister1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KENIT </h3>
                <h4>(HEALTH & ENVIROMENT MINISTER)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/sports-captain.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>SARANSH </h3>
                <h4> (SPORTS CAPTAIN)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/sports-captain1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>JIYA </h3>
                <h4> (SPORTS CAPTAIN)</h4>
              </article>
            </div>

            <div className="clr"></div>
            <div className="col-lg-12">
              <h2 className="text-center m-4">
                <small> Gandhi House</small>
              </h2>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>MAULIK </h3>
                <h4>( HOUSE CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>CHAHAK </h3>
                <h4> ( HOUSE CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiViceCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DAKSH </h3>
                <h4>( VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-3.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ISHIKA </h3>
                <h4> ( VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiSportsCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>MEET </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-4.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AVVAL </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DIVITA </h3>
                <h4> (PREFECTS) </h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiViceCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>LAKSHAY </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiSportsCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>NAKSH </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>NEHAL SINGH </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-5.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>PAWNI </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-6.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>VARIYAM </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-7.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>HARDIK </h3>
                <h4>(JR.PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/GandhiHousePrefect-8.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>PAARTHVI </h3>
                <h4>(JR.PREFECTS)</h4>
              </article>
            </div>

            <div className="clr"></div>
            <div className="col-lg-12">
              <h2 className="text-center m-4">
                <small>RAMAN HOUSE</small>
              </h2>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanSportsCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>RUDRA </h3>
                <h4>(HOUSE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KIRTIKA </h3>
                <h4>(HOUSE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanViceCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>HIMANSHI </h3>
                <h4>(VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-5.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>YUVAL </h3>
                <h4> (VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-4.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>- </h3>
                <h4> (SPORTS CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanSportsCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ADITYA </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AARAV </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanViceCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ABI ROY </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ANKITA </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-3.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>BHARAT </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-3.1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KAVYA </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-3.2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KIRAN </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-3.3.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AMAN </h3>
                <h4>(JR. PREFECT)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/RamanHousePrefect-3.4.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>NIKHIL </h3>
                <h4>(JR. PREFECT)</h4>
              </article>
            </div>

            <div className="col-lg-12">
              <h2 className="text-center m-4">
                <small>TERESA HOUSE</small>
              </h2>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AARAV </h3>
                <h4>(HOUSE CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-4.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>RIDHI </h3>
                <h4>(HOUSE CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DAKSH </h3>
                <h4>(VICE CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-5.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>LAMISHA </h3>
                <h4>(VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaViceCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>RIKESH </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KAVYA </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>BHAVIN SHARMA </h3>
                <h4> (PREFECTS) </h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>CHAVIT BHYAN </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KARMJOT </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-3.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>RADHIKA </h3>
                <h4> (PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-3.1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>RUDRADEEP </h3>
                <h4> (PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-3.2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>SUPRIA </h3>
                <h4> (PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-3.3.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>TASHI </h3>
                <h4> (PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TeresaSportsPrefect-3.4.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>YASHIKA </h3>
                <h4> (PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-12">
              <h2 className="text-center m-4">
                <small>TAGORE HOUSE</small>
              </h2>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-4.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>KARTIK </h3>
                <h4>(HOUSE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-7.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>HINAL </h3>
                <h4>(HOUSE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-5.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DHANVI </h3>
                <h4> (VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AARAV </h3>
                <h4>(VICE CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-3.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ANSH </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-6.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AISHNOOR KOUR </h3>
                <h4>(SPORTS CAPTAINS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreCaptain-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AARDHYA </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreViceCaptain-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AGRIM </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>

            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>AKSHAT </h3>
                <h4> (PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ARMAN SINGH </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-8.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>DIKSHA </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-9.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>ISHAN </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-9.1.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>NAVYA </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6">
              <article>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cabinet/TagoreSportsPrefect-9.2.JPG"
                    alt="sfxhisar"
                    className="img-fluid mx-auto d-block"
                  />
                </LazyLoad>
                <h3>REHAN </h3>
                <h4>(PREFECTS)</h4>
              </article>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SchoolCabinet;
